var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.16092 8.5339L3.15937 8.63391H2.50024H2.40024V8.53391V6.71815C2.40024 5.93589 3.03623 5.2999 3.81849 5.2999H11.7657H11.9222L11.8564 5.44193L11.0628 7.15528L3.16092 8.5339ZM3.16092 8.5339H3.25927C3.25927 8.22588 3.51022 7.9749 3.8184 7.9749L9.77678 7.97478C10.3278 7.97478 10.8326 7.65343 11.0628 7.15536L3.16092 8.5339ZM3.81849 6.15915H3.81849L10.5776 6.15902L10.2835 6.7946L10.2834 6.79464C10.1935 6.98923 9.99461 7.11578 9.77687 7.11578H3.81849C3.62027 7.11578 3.43111 7.15674 3.25937 7.23072V6.71827C3.25937 6.41011 3.51033 6.15915 3.81849 6.15915Z",
    fill: "#686D7C",
    stroke: "#686D7C",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9095 5.3337L11.9094 5.33385L11.0625 7.15587L11.9095 5.3337ZM11.9095 5.3337C12.0008 5.13635 12.1986 5.00943 12.4128 5.00943H17.0003C17.3084 5.00943 17.5594 5.26039 17.5594 5.56855L17.5595 15.432C17.5595 15.7401 17.3085 15.9911 17.0004 15.9911H3.81824C3.51008 15.9911 3.25912 15.7401 3.25912 15.432V8.53443C3.25912 8.22627 3.51008 7.97531 3.81824 7.97531M11.9095 5.3337L3.81824 7.97531M3.81824 7.97531L9.77642 7.97537C10.3274 7.97537 10.8321 7.65406 11.0624 7.15607L3.81824 7.97531ZM17.0004 16.85H17.2418L17.2241 16.8323C17.9003 16.7247 18.4185 16.1378 18.4185 15.4317V5.56824C18.4185 4.78599 17.7825 4.15 17.0003 4.15H12.4131C11.8646 4.15 11.3613 4.47289 11.131 4.9709C11.131 4.97095 11.131 4.971 11.1309 4.97105L10.2833 6.79464L10.2832 6.79484C10.1933 6.98942 9.99437 7.11597 9.77663 7.11597H3.81824C3.03599 7.11597 2.4 7.75196 2.4 8.53422V15.4318C2.4 16.214 3.03599 16.85 3.81824 16.85H17.0004Z",
    fill: "#686D7C",
    stroke: "#686D7C",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectIcon);
export default __webpack_public_path__ + "static/media/project-icon.59a8d5433f2b6ffdeadc1884b00c75d8.svg";
export { ForwardRef as ReactComponent };